var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16PlayCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm-.797 3.115c-.502-.305-1.125.032-1.196.609L6 5.834v4.332c0 .605.593.995 1.108.769l.095-.05 3.4-2.165c.494-.3.527-1.014.099-1.37l-.099-.07-3.4-2.165Z",
  clipRule: "evenodd"
})));
export default SvgIc16PlayCircle;